export default function (context) {
  const user = context.$auth.$storage.getState('user')
  if (user.invitatorId !== null) return context.redirect('/tickets')
}
